const dataURItoBlob = (dataURI: string) => {
  const byteString = atob(dataURI.split(",")[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: "image/jpeg" });
};

const captureVideo = (player: Element) => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  const videoTag = player.querySelector("video");
  if (!videoTag) return "";
  const ratio = videoTag.videoWidth / videoTag.videoHeight;
  // Define the required width as 100 pixels smaller than the actual video's width
  const w = videoTag?.videoWidth - 100;
  // Calculate the height based on the video's width and the ratio
  // const h = parseInt(w / ratio, 10);
  const h = w / ratio;
  // Set the canvas width and height to the values just calculated
  canvas.width = w;
  canvas.height = h;
  context?.fillRect(0, 0, w, h);
  context?.drawImage(videoTag!, 0, 0, w, h);
  // canvas.toBlob()
  const blob = dataURItoBlob(canvas.toDataURL("image/jpg", 1.0));
  // basee64
  // const data = canvas.toDataURL("image/jpg", 1.0);
  const file = new File([blob], "File Name", { type: "image/jpeg" });
  return file;
};

export default captureVideo;
